import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatFormFieldAppearance } from '@angular/material/form-field';
import { SetupAttributesInterface } from '../../interface/setupattributes.interface';

import { AssetService } from '../../models/assetservice.class';
import { Field } from '../../models/field.class';
import { Message } from '../../models/record/message.class';
import { RecordField } from '../../models/record/recordfield.class';
import { LookupsService } from '../../services/lookups/lookups.service';

@Component({
    selector: 'app-assetlookup',
    templateUrl: './assetlookup.component.html',
    styleUrls: ['./assetlookup.component.scss'],
    standalone: false,
})
export class AssetlookupComponent implements OnInit, OnChanges {
    @Input() field: SetupAttributesInterface['field'] | any;
    @Input() conditionalValue: string;
    @Input() required: boolean;
    @Input() errors: Message['errors'];
    @Input() warnings: Message['warnings'];
    @Input() disabled: boolean;
    @Input() service: AssetService;
    @Input() item: any;
    @Input() fieldValue: SetupAttributesInterface['fieldValue'];
    @Input() name: string;
    @Input() gridCellIndex: string;
    @Input() description: string;
    @Input() appearance: MatFormFieldAppearance;

    @Output() modelChange = new EventEmitter();

    options: any[];

    constructor(private _lookUps: LookupsService) {}

    ngOnChanges(changes: SimpleChanges) {
        // Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
        if (changes.conditionalValue) {
            if (!changes.conditionalValue.firstChange) {
                if (this.field instanceof RecordField) {
                    this.field.value = '';
                } else {
                    this.fieldValue = '';
                }
                this.modelChange.emit('');
                this.fetchOptionsByCondition();
            } else if (
                changes.conditionalValue &&
                changes.conditionalValue.currentValue &&
                changes.conditionalValue.currentValue.length > 0
            ) {
                this.fetchOptionsByCondition();
            }
        }
        this.checkUIType();
    }

    fetchOptionsByCondition = () => {
        if (this.field instanceof RecordField) {
            this._lookUps.fetchLookupValuesByRecordField(
                {
                    conditionalValue: this.conditionalValue,
                    field: this.field,
                    service: this.service,
                    gridCellIndex: this.gridCellIndex,
                },
                {
                    successCallback: lookupValues => {
                        if (this.field instanceof RecordField) {
                            this.field.setLookupValues(lookupValues);
                            this.loadOptions();
                        } else {
                            const response = lookupValues && lookupValues.displayVsValue;
                            this.options = [];
                            Object.keys(response || {}).forEach(key => {
                                this.options.push({
                                    displayName: key,
                                    value: response[key],
                                });
                            });
                        }
                        this.checkUIType();
                    },
                }
            );
        } else if (this.field instanceof Field) {
        } else {
            this._lookUps.fetchLookupValuesByField(
                {
                    conditionalValue: this.conditionalValue,
                    field: this.field,
                    service: this.service,
                    gridCellIndex: this.gridCellIndex,
                },
                {
                    successCallback: lookupValues => {
                        if (this.field instanceof RecordField) {
                            this.field.setLookupValues(lookupValues);
                            this.loadOptions();
                        } else {
                            const response = lookupValues && lookupValues.displayVsValue;
                            this.options = [];
                            Object.keys(response || {}).forEach(key => {
                                this.options.push({
                                    displayName: key,
                                    value: response[key],
                                });
                            });
                        }
                        this.checkUIType();
                    },
                }
            );
        }
    };

    checkUIType = () => {
        if (this.field.originalUiType === 'RADIOBUTTON') {
            if (this.options?.length > 0 && this.options?.length <= 2) {
                this.field.uiType = 'RADIOBUTTON';
            } else {
                this.field.uiType = 'DROPDOWN';
            }
        }
    };

    loadOptions = () => {
        if (this.field instanceof RecordField && this.field.lookupValues && this.field.lookupValues.displayVsValue) {
            this.options = [];
            for (let i = 0; i < this.field.lookupValues.displayVsValue.length; i++) {
                this.options.push({
                    displayName: this.field.lookupValues.displayVsValue[i].key,
                    value: this.field.lookupValues.displayVsValue[i].value,
                });
            }
            this.checkUIType();
        } else {
            this.fetchOptionsByCondition();
        }
    };

    valueChanged = (event: any) => {
        this.modelChange.emit(event);
    };

    checkIfRadioBtnSelected = option => {
        if (this.item?.fieldValue) {
            if (this.item.fieldValue === option.value) {
                return true;
            }
        } else if (this.field) {
            if (this.field.value === option.value) {
                return true;
            }
        }
        return false;
    };

    ngOnInit() {
        this.loadOptions();
    }
}
